export default __webpack_public_path__ + "static/media/icon_3.74d6c331.svg";